import { redirect, type RouteObject } from 'react-router';
import {
  consentSearchSchema,
  loginSearchSchema,
  parseSearchLoader,
  passwordSearchSchema,
} from '@/shared/navigation';
import { ROUTES } from '@/shared/routing';
import { standaloneLayout } from '@/app/layouts';
import { composeLoaders } from '../compose-loaders';
import type { NavigationGuards } from '../navigation.guard';

/** 인증 화면 — login · consent · password (`/auth/*`). */
export function createAuthRoute(guards: NavigationGuards): RouteObject {
  return {
    element: standaloneLayout({ width: 'sm' }), // TODO: 라우트별 width 값 지정 ('sm'|'md'|'lg'|'full')
    path: ROUTES.AUTH,
    children: [
      { index: true, loader: () => redirect(ROUTES.AUTH_LOGIN) },
      {
        path: ROUTES.AUTH_LOGIN,
        loader: composeLoaders(guards.requireGuest, parseSearchLoader(loginSearchSchema)),
        lazy: { Component: () => import('@/pages/login').then((m) => m.LoginPage) },
      },
      {
        path: ROUTES.AUTH_CONSENT,
        // `requireConsent` 는 여기 걸지 않는다 — 동의 화면 자신이라 self-loop. 이미 동의 완료 상태로
        // 직접 진입한 경우는 페이지가 pass-through 로 처리한다.
        loader: composeLoaders(guards.requireAuth, parseSearchLoader(consentSearchSchema)),
        lazy: { Component: () => import('@/pages/consent').then((m) => m.ConsentPage) },
      },
      {
        path: ROUTES.AUTH_PASSWORD,
        loader: composeLoaders(guards.requireAuth, parseSearchLoader(passwordSearchSchema)),
        lazy: { Component: () => import('@/pages/password').then((m) => m.PasswordPage) },
      },
    ],
  };
}
